const storagePrefix = 'msw-db';

const storage = {
  setUserPhoneNumber: (phoneNumber) => {
    window.localStorage.setItem(`${storagePrefix}userPhoneNumber`, phoneNumber);
  },
  getUserPhoneNumber: () => {
    return window.localStorage.getItem(`${storagePrefix}userPhoneNumber`);
  },
  getToken: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}token`));
  },
  setToken: (token) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },
};

export default storage;
